import type { WorksheetSize } from "@arbeidsark/shared"
import {
  SVGIcon,
  Select,
  type SelectOption,
  type SelectProps,
} from "~/components"
import { useTranslate } from "~/ur-react-hooks"

export interface LayoutSelectProps
  extends Omit<SelectProps<WorksheetSize>, "options"> {}

const LayoutSelect: React.FC<LayoutSelectProps> = ({ ...props }) => {
  const translations = useTranslate({
    pageLayoutFull: "worksheets.page-layouts.full",
    pageLayoutHalf: "worksheets.page-layouts.half",
  })

  const options: SelectOption<"full" | "half">[] = [
    {
      value: "full",
      label: translations.pageLayoutFull,
      icon: <SVGIcon icon={"Layout_one"} />,
    },
    {
      value: "half",
      label: translations.pageLayoutHalf,
      icon: <SVGIcon icon={"Layout_1x1"} />,
    },
  ]

  return <Select {...props} options={options} />
}

export default LayoutSelect
